try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

(function ($) {
    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('#navbarResponsive').toggleClass('show');
    });

    // Start of use strict
    $('.obfiscate').each(function (index) {
        $(this).replaceWith(`<a href="mailto:${$(this).data('name')}@${$(this).data('domain')}" >${$(this).data('name')}@${$(this).data('domain')}</a>`);
    });
}(jQuery)); // End of use strict



// WEBPACK FOOTER //
// ./Themes/Zsd/resources/js/theme.js